import React, { createContext, useState } from 'react';

export const DefaultContext = createContext();

export const UserProvider = ({ children }) => {
    const [LNG, setLNG] = useState(true);

    return (
        <DefaultContext.Provider
            value={{
                LNG,
                setLNG
            }}
        >
            {children}
        </DefaultContext.Provider>
    );
};